import { Capacitor, registerPlugin } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

const AgeSignals = registerPlugin('BlopAgeSignals');
const MediaSaver = registerPlugin('BlopMediaSaver');
const PlayIntegrity = registerPlugin('BlopPlayIntegrity');
const GoogleAuth = registerPlugin('BlopGoogleAuth');
const SecureSession = registerPlugin('BlopSecureSession');
let cachedToken;

export const isNativeAndroid = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';

export async function requestPlayAgeSignals() {
  if (!isNativeAndroid()) return { status: 'web', isAdult: false };
  return AgeSignals.request();
}

export async function saveArtworkOnDevice(url, fileName) {
  if (!isNativeAndroid()) return null;
  return MediaSaver.saveImage({ url, fileName, token: await getNativeToken() });
}

export async function getNativeToken() {
  if (!isNativeAndroid()) return null;
  if (cachedToken !== undefined) return cachedToken;
  try {
    cachedToken = (await SecureSession.get()).value || null;
    if (!cachedToken) {
      const legacy = (await Preferences.get({ key: 'blopboru_access_token' })).value || null;
      if (legacy) {
        await SecureSession.set({ value: legacy });
        await Preferences.remove({ key: 'blopboru_access_token' });
        cachedToken = legacy;
      }
    }
  }
  catch (_) { cachedToken = null; }
  return cachedToken;
}
export async function setNativeToken(token) {
  if (!isNativeAndroid() || !token) return;
  await SecureSession.set({ value: token });
  await Preferences.remove({ key: 'blopboru_access_token' });
  cachedToken = token;
}
export async function clearNativeToken() {
  cachedToken = null;
  if (isNativeAndroid()) {
    await SecureSession.clear();
    await Preferences.remove({ key: 'blopboru_access_token' });
  }
}
export const nativeRequestHeaders = () => isNativeAndroid() ? {'X-BlopBoru-Client':'android-native'} : {};

export async function signInWithGoogleNative(serverClientId) {
  if (!isNativeAndroid()) throw new Error('Login nativo disponível somente no Android.');
  return GoogleAuth.signIn({ serverClientId });
}

export async function requestAgeIntegrityToken(challenge, subject, signals) {
  const canonical = ['age-verification-v1', challenge, subject, signals.installId,
    signals.ageLower ?? '', signals.ageUpper ?? '', signals.ageRangeSource ?? ''].join('|');
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(canonical));
  const requestHash = btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  const result = await PlayIntegrity.requestToken({ requestHash });
  return { token: result.token, requestHash };
}
